import { motion, useAnimation } from 'framer-motion';
import { useEffect, useState } from 'react';
import AOS from 'aos';
import logo56 from './56logo.png';

const AnimatedLogo = ({ onAnimationComplete }) => {
  const controls = useAnimation();
  const [animationCompleted, setAnimationCompleted] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // Eğer animasyon zaten tamamlandıysa, tekrar çalıştırma
    if (animationCompleted) return;

    // Scroll'u devre dışı bırak ve AOS'u disable et
    document.body.style.overflow = 'hidden';
    
    const animateSequence = async () => {
      // Merkeze fade-in ve blur efekti ile netleşme
      await controls.start({
        opacity: 1,
        filter: 'blur(0px)',
        scale: typeof window !== 'undefined' && window.innerWidth < 768 ? 1.4 : 2,
        x: '-50%',
        y: '-50%',
        top: '50%',
        left: '50%',
        transition: { duration: 1.8, ease: 'easeOut' },
      });

      await new Promise((res) => setTimeout(res, 1500));

      // Sol üst köşeye kaydır - pozisyon ve scale aynı anda smooth geçiş
      await controls.start({
        top: '0.5rem',
        left: '1.5rem', 
        x: 0,
        y: 0,
        scale: 0.5, // Küçültme oranını ayarladım
        filter: 'blur(0px)',
        transition: { 
          duration: 1.2, 
          ease: "easeInOut",
          // Tüm özellikler aynı süre ve easing ile
          top: { duration: 1.2, ease: "easeInOut" },
          left: { duration: 1.2, ease: "easeInOut" },
          scale: { duration: 1.2, ease: "easeInOut" },
          x: { duration: 1.2, ease: "easeInOut" },
          y: { duration: 1.2, ease: "easeInOut" }
        },
      });

      // Animasyon tamamlandı, scroll'u tekrar aktive et ve AOS'u yeniden başlat
      setTimeout(() => {
        document.body.style.overflow = 'auto';
        // AOS'u yeniden initialize et
        AOS.init({
          duration: 600,
          easing: 'ease-out-cubic',
          once: true,
          offset: 50,
          delay: 0,
        });
        // Animasyon tamamlandı olarak işaretle
        setAnimationCompleted(true);
        // Callback fonksiyonunu çağır
        if (onAnimationComplete) {
          onAnimationComplete();
        }
      }, 500);
    };

    animateSequence();

    // Cleanup function - component unmount olduğunda scroll'u aktive et
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [controls, onAnimationComplete, animationCompleted]);

  // Scroll event listener ekle
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 100); // 100px aşağı scroll yapıldığında gizle
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.div
      initial={{
        opacity: 0,
        filter: 'blur(10px)',
        scale: typeof window !== 'undefined' && window.innerWidth < 768 ? 1.4 : 2,
        x: '-50%',
        y: '-50%',
        top: '50%',
        left: '50%',
      }}
      animate={animationCompleted ? {
        opacity: isScrolled ? 0 : 1,
        filter: 'blur(0px)',
        scale: 0.5,
        x: 0,
        y: 0,
        top: '0.5rem',
        left: '1.5rem',
      } : controls}
      className="transition-opacity duration-300 relative"
      style={{
        position: 'fixed',
        zIndex: 9999
      }}
    >
        {/* Animated Logo */}
        <div className="relative">
          <div className="w-32 h-32 md:w-40 md:h-40 lg:w-48 lg:h-48 bg-white rounded-full flex items-center justify-center shadow-2xl relative z-10 p-4">
            <img 
              src={logo56} 
              alt="N56OTOLASTİK Logo" 
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </motion.div>
  );
};

export default AnimatedLogo;
